<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M14.2197 15.281C14.5125 15.5739 14.9874 15.5739 15.2803 15.281C15.5732 14.988 15.5732 14.5132 15.2803 14.2203L14.2197 15.281ZM12.8106 12.8113C12.2249 13.3971 11.2751 13.3971 10.6893 12.8113L9.62868 13.872C10.8003 15.0435 12.6997 15.0435 13.8713 13.872L12.8106 12.8113ZM10.6893 12.8113C10.1035 12.2255 10.1035 11.2758 10.6893 10.6899L9.62868 9.62929C8.45711 10.8009 8.45711 12.7004 9.62868 13.872L10.6893 12.8113ZM10.6893 10.6899C11.2751 10.1042 12.2249 10.1042 12.8106 10.6899L13.8713 9.62929C12.6997 8.45772 10.8003 8.45772 9.62868 9.62929L10.6893 10.6899ZM12.8106 10.6899C13.3965 11.2758 13.3965 12.2255 12.8106 12.8113L13.8713 13.872C15.0429 12.7004 15.0429 10.8009 13.8713 9.62929L12.8106 10.6899ZM12.8106 13.872L14.2197 15.281L15.2803 14.2203L13.8713 12.8113L12.8106 13.872Z"
    :fill="stroke || 'currentColor'"/>
    <path d="M5.05006 9.99976H5.20006M5.05006 14.8748H5.20006M14.8001 5.12476H14.9501M9.92506 5.12476H10.0751M5.05006 5.12476H5.20006M5.50006 9.99976C5.50006 10.2068 5.33217 10.3748 5.12506 10.3748C4.91796 10.3748 4.75006 10.2068 4.75006 9.99976C4.75006 9.79268 4.91796 9.62476 5.12506 9.62476C5.33217 9.62476 5.50006 9.79268 5.50006 9.99976ZM5.50006 14.8748C5.50006 15.0818 5.33217 15.2498 5.12506 15.2498C4.91796 15.2498 4.75006 15.0818 4.75006 14.8748C4.75006 14.6677 4.91796 14.4998 5.12506 14.4998C5.33217 14.4998 5.50006 14.6677 5.50006 14.8748ZM15.2501 5.12476C15.2501 5.33186 15.0821 5.49976 14.8751 5.49976C14.668 5.49976 14.5001 5.33186 14.5001 5.12476C14.5001 4.91765 14.668 4.74976 14.8751 4.74976C15.0821 4.74976 15.2501 4.91765 15.2501 5.12476ZM10.3751 5.12476C10.3751 5.33186 10.2071 5.49976 10.0001 5.49976C9.79299 5.49976 9.62506 5.33186 9.62506 5.12476C9.62506 4.91765 9.79299 4.74976 10.0001 4.74976C10.2071 4.74976 10.3751 4.91765 10.3751 5.12476ZM5.50006 5.12476C5.50006 5.33183 5.33214 5.49976 5.12506 5.49976C4.91799 5.49976 4.75006 5.33183 4.75006 5.12476C4.75006 4.91768 4.91799 4.74976 5.12506 4.74976C5.33214 4.74976 5.50006 4.91768 5.50006 5.12476Z"
    :fill="stroke || 'currentColor'" :stroke="stroke || 'currentColor'" stroke-width="1.5" stroke-linecap="square"/>
  </svg>
</template>

<script>
export default {
  name: 'CategoriesIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    stroke: {
      type: String,
      default: null
    }
  }
}
</script>

<style scoped></style>
